// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1uhUq","inputWrap":"styles_inputWrap__2FyAr","input":"styles_input__2UwbF"};